import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';

class HtmlComponent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			// text: props.text,
			isParsed: false,
		};

		this.id = uuidv4();

	}

	shouldComponentUpdate(nexProps, nextState) {
		return this.props.text !== nexProps.text || this.state.isParsed !== nextState.isParsed;
	}

	transform = (node, index) => {
		// if(node.type === 'tag' && node.name.includes('math')) {
		//     console.log(node, index);
		//     return null;
		// }
	}

	renderHtml() {
		try {
			if(this.props.text) {
				if(typeof document !== 'undefined' && typeof window !== 'undefined') { // Handle SSR
					const textWrapper = document.getElementById(this.id);

					// Patch for Wiris plugin, see: https://docs.wiris.com/en/mathtype/mathtype_web/integrations/mathml-mode
					setTimeout(() => {
						// const textWrappers = document.getElementsByClassName('html-text-wrapper');
						// for(let i = 0; i < textWrappers.length; i++) {
						// textWrapper && window.com.wiris.js.JsPluginViewer.parseElement(textWrapper, true, () => {
						this.setState({
							isParsed: true,
						});
						// });
						// }
					}, 100);
				}
				// return reactHtmlParser(this.state.text, {
				//     transform: this.transform,
				// });
				return <div dangerouslySetInnerHTML={{ __html: this.props.text }} />;
			}
		} catch (err) {
			console.error('renderHtml', err);
			return null;
		}
	}

	render() {
		return (
			<div id={this.id} className="html-text-wrapper">{this.renderHtml()}</div>
		);
	}
}

HtmlComponent.propTypes = {
	text: PropTypes.string.isRequired,
};

export default HtmlComponent;
